import Breadcrumb from "../../Component/Breadcrumb";

function Admission() {
  return (
    <>
      <Breadcrumb>Students / Admission</Breadcrumb>
      <div className="innersec admission_sec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Admission</h1>
          </div>
          <ol>
            <li>
              The list of the children selected for admission will be published
              on the school notice board on the date given.
            </li>
            <li>
              The parents shall deposit the first installment of the fees at the
              time of admission.
            </li>
            <li>
              Admission of the selected children shall be taken on the assigned
              days. Those who fail to respond shall forfeit their chance.
            </li>
            <li>
              The following documents are essential at the time of admission:
              <ol type="I">
                <li>
                  Birth Certificate from the competent authority, such as:
                  Panchayat / Nagarpalika. No other certificate from whatever
                  source it be, will be accepted. (Only for LKG)
                </li>
                <li>PEN Number is mandatory (Class I to XI)</li>
                <li>
                  Transfer Certificate & Character Certificate from the school
                  last attended.
                </li>
                <li>
                  A Xerox copy of mark list (report card) along with the
                  original.
                </li>
                <li>
                  Medical Fitness Certificate, certified by a physician in Govt.
                  Service.
                </li>
              </ol>
            </li>
            <li>
              Admission of the student in the school will be on the basis of
              merit.
            </li>
            <li>
              For taking admission, the parents of the student must inevitably
              be present and sign the admission form.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
}
export default Admission;
